import { FileWorkspace } from '../../components/FileWorkspace';

export default function BuilderDocuments() {
  return <div className="space-y-8"><h1 className="text-3xl font-black text-white">Plans & Documents</h1><p className="text-sm text-slate-400">Share project files privately with the Hardwire office.</p><FileWorkspace dark /></div>;
}
